import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedSettingsService {
  private settingsSubject: BehaviorSubject<any>;

  constructor() {
    const settingsString = localStorage.getItem('settings');
    const initialSettings = settingsString ? JSON.parse(settingsString) : {};
    this.settingsSubject = new BehaviorSubject<any>(initialSettings);
  }

  get(): Observable<any> {
    return this.settingsSubject.asObservable().pipe(map((settings) => settings as any));
  }
  set(settings: any): void {
    localStorage.setItem('settings', JSON.stringify(settings));
    this.settingsSubject.next(settings);
  }
}
